import { Logo } from "Components";
import React from "react";

function Processing({ flight }) {
	if (!flight) {
		return null;
	}

	const { logo, name, code } = flight || {};

	return (
		<div className="w-full h-full p-3 sm:p-6 flex-center bg-light">
			<div className="w-full max-w-md p-5 border shadow-sm rounded-xl bg-canvas sm:p-6">
				<div className="text-center">
					<img src={logo} alt={name} className="w-14 h-14 m-auto rounded-full shadow-md" />
					<div className="mt-3 text-sm font-semibold">{name}</div>
					<div className="text-xs text-secondary">{code}</div>
					<div className="inline-block px-3 py-1 mt-3 text-xs font-medium rounded-full bg-light text-secondary">Finalizing with airline</div>
				</div>

				<div className="mt-5">
					<span className="block max-w-xs m-auto payment-loader"></span>
				</div>

				<div className="mt-6 text-center">
					<h4>We are confirming your booking</h4>
					<div className="mt-2 text-label">Please keep this page open while we secure your ticket. This usually takes less than a minute.</div>
				</div>

				<div className="p-3 mt-5 space-y-2 text-xs border rounded-md bg-light border-surface">
					<div className="text-secondary">- Revalidating final fare and seat availability</div>
					<div className="text-secondary">- Issuing ticket with the airline</div>
					<div className="text-secondary">- Preparing your booking confirmation</div>
				</div>

				<div className="mt-5 text-center">
					<Logo className="m-auto" />
				</div>
			</div>
		</div>
	);
}

export default Processing;
